import React from 'react';
import { Button } from '../ui/button';

// A game title that is also the row's action (open/select the game), as a
// real button so keyboard users can reach it — the clickable table row around
// it isn't focusable. Stops the click from also firing the row's handler.
export default function GameTitleButton({ title, onActivate, label }) {
  return (
    <Button
      type="button"
      variant="link"
      aria-label={label}
      onClick={e => { e.stopPropagation(); onActivate(); }}
      className="h-auto p-0 font-bold text-ink whitespace-normal text-left justify-start"
    >
      {title}
    </Button>
  );
}
